import { NavigateLink } from '@/components/navigate/NavigateLinks.tsx';
import { fleetPageBreadcrumbs } from '../../config/breadcrumbs';
import { NavigateFunction } from 'react-router-dom';

export const childrenCompaniesPageBreadcrumbs = (navigate: NavigateFunction): NavigateLink[] => [
  ...fleetPageBreadcrumbs(navigate),
  { label : 'Compañías', onClick: () => navigate('/fleet/companies') },
];
